module.exports = __webpack_public_path__ + "img/bg-footer.6ea184ab.jpg";